// Client-side CSV export — used by DataTable's optional `csvExport` prop.
// No network round-trip: the rows are already loaded, so we just serialize
// what's in memory and hand the browser a Blob to save.
export interface CsvColumn {
  key: string;
  header: string;
}

function escapeCsvCell(value: unknown): string {
  const str = value === null || value === undefined ? "" : String(value);
  return /[",\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
}

export function downloadCsv<TRow>(fileName: string, rows: TRow[], columns: CsvColumn[]) {
  const headerLine = columns.map((c) => escapeCsvCell(c.header)).join(",");
  const bodyLines = rows.map((row) => columns.map((c) => escapeCsvCell((row as any)?.[c.key])).join(","));
  const csv = [headerLine, ...bodyLines].join("\r\n");

  // Leading BOM so Excel opens UTF-8 (₹, non-Latin names, etc.) without mangling it.
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName.toLowerCase().endsWith(".csv") ? fileName : `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
